import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const TokenManager = () => {
  const [accessToken, setAccessToken] = useState(sessionStorage.getItem('access_token'));
  const [refreshToken, setRefreshToken] = useState(sessionStorage.getItem('refresh_token'));
  const [expiresAt, setExpiresAt] = useState(sessionStorage.getItem('tokenExpirationTime'));
  const navigate = useNavigate();

  const refreshAccessToken = async () => {
    try {
      // Make the API call to refresh the token
      const response = await axios.post('/api/refresh', { refreshToken });
      console.log('Token expired, updating...');

      const { accessToken: newAccessToken, expiresAt: newExpiresAt, refreshToken: newRefreshToken } = response.data;

      // Update tokens and expiration time
      setAccessToken(newAccessToken);
      setExpiresAt(newExpiresAt);
      setRefreshToken(newRefreshToken);

      sessionStorage.setItem('access_token', newAccessToken);
      sessionStorage.setItem('tokenExpirationTime', newExpiresAt);
      sessionStorage.setItem('refresh_token', newRefreshToken);

      toast.info("Token updated successfully");
    } catch (error) {
      console.error('Failed to refresh access token:', error);
      // Uncomment these lines if you want to navigate or show an error when token refresh fails
      // toast.error("Failed to refresh token. Please log in again.");
      // navigate('/skyblue');
    }
  };

  useEffect(() => {
    const checkTokenExpiration = () => {
      console.log('Checking token expiration...');

      // Get the current time in UTC milliseconds
      const currentTime = Date.now();

      // Convert expiresAt from string to UTC date and get the time in milliseconds
      const expirationTime = new Date(expiresAt).getTime();

      // Calculate time until expiration
      const timeUntilExpiration = expirationTime - currentTime;

      console.log('Current Time (UTC):', new Date(currentTime).toUTCString());
      console.log('Expiration Time (UTC):', new Date(expirationTime).toUTCString());
      console.log('Time Until Expiration (ms):', timeUntilExpiration);

      // Refresh token if it's within 5 minutes of expiring
      if (timeUntilExpiration <= 300000) { // 300,000 ms = 5 minutes
        refreshAccessToken();
      } else {
        console.log('Token is valid, no need to refresh yet.');
      }
    };

    // Set interval to check every 30 seconds
    const intervalId = setInterval(checkTokenExpiration, 30000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [expiresAt, refreshToken]); // Add refreshToken to dependencies to handle updates

  // Uncomment this line if you want to render something
  // return <div>{accessToken ? 'Authenticated' : 'Not Authenticated'}</div>;
};

export default TokenManager;
